export const SET_FEED = 'SET_FEED';
export const SET_FULL_VIDEO_OFFENCE = 'SET_FULL_VIDEO_OFFENCE';
export const RESET_FULL_VIDEO_OFFENCE = 'RESET_FULL_VIDEO_OFFENCE';
export const UPDATE_KEYS_IN_FEED = 'UPDATE_KEYS_IN_FEED';
export const SET_CREATE_OFFENCE_DATA = 'SET_CREATE_OFFENCE_DATA';
export const RESET_CREATE_OFFENCE_DATA = 'RESET_CREATE_OFFENCE_DATA';
export const SET_THUMBNAIL = 'SET_THUMBNAIL';
